import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import type { ControllerDetails } from '#services/cve/ControllerDetails';
import { IterationStatusCode, LineOfBusiness, VettingIteration } from '#services/cve/VettingIteration';

const sanctionsDetails: ControllerDetails = {
  controlCode: 'EconomicSanctions',
  statusCode: ControllerStatus.ESCALATION_REJECTED,
  check: {
    requestorId: 'CVE',
    requestDateTime: '2024-05-21T13:29:56.409Z',
    responseDateTime: '2024-05-21T13:29:56.409Z',
    expirationDateTime: '2999-05-21T13:29:56.409Z',
    controlData: {
      sanctions: [
        {
          companyId: '113',
          sanctionId: '115250479-20230317135606274587',
          sanctionSource: {
            originCode: 'Manual creation',
            updateOriginCode: 'Manual creation',
          },
          sanctionTypeCode: 'SP',
          sanctionUpdateDateTime: '2023-03-17',
          sanctionCreationDate: '2023-03-17',
          isContinuatedSanction: true,
          sanctionEffectiveEndDate: '2025-03-17',
          isActive: true,
        },
      ],
      consecutiveSanctionsEndDate: '2025-03-17',
      rejectCode: 'ONGOING_SANCTION',
      escalationContact: 'test@allianz-trade.com',
    },
  },
  escalation: {
    requestorId: 'CVE',
    requestDateTime: '2024-05-21T13:29:56.409Z',
    responseDateTime: '2024-05-21T13:29:56.409Z',
    expirationDateTime: '2999-05-21T13:29:56.409Z',
    controlData: {
      escalationResponse: {
        validator: 'johndoe',
        comment: "I won't accept this",
      },
    },
  },
};

export const escalationDeclinedMock: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/EconomicSanctions$',
    },
    response: {
      status: 200,
      body: sanctionsDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId$',
    },
    response: {
      status: 200,
      body: {
        iterationId: 'iterationId',
        lineOfBusiness: LineOfBusiness.TCI,
        companyId: '113',
        statusCode: IterationStatusCode.REJECTED,
        creation: {
          creationDateTime: '2024-04-19T10:05:42.156Z',
          creatorId: 'CVE',
          ownerId: 'CVE',
        },
        closure: {
          closureDateTime: '2024-04-19T10:05:42.156Z',
          requestorId: 'CVE',
        },
        controls: [
          {
            controlCode: 'CompanyGrade',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          sanctionsDetails,
          {
            controlCode: 'SensitiveBusiness',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'SensitiveCountry',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'EnergyPolicy',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'PoliticalExposedPerson',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'Gerl',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'ReputationalRisk',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'CompanyConsortOrCoop',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'AccountOwner',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'AccountDetails',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'BuExchangeGroup',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'MncList',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'PreviousContract',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'PreviousNegociation',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'ProspectLocation',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'UnpaidPremiumAndFees',
            statusCode: ControllerStatus.NOT_STARTED,
          },
        ] satisfies ControllerDetails[],
        customProperties: {},
      } satisfies VettingIteration,
    },
  },
];
